<div [formGroup]="contactInfoForm">
    <div>
      <!--Contact Information Header-->
      <!-- Commenting this as this will be part of Additional Information -->
      <!--<div id="sd_contact_info" class="py-2">{{ 'ContactInfo.contactInformation' | translate }}</div>-->
      <!--Preferred Mode-->
      <div class="row mt-3">
        <div class="col-md-2 col-lg-2 col-xl-2">
            <label class="ml-2" for="contactType" id="sd_contact_type_label">
                {{ 'ContactInfo.contactTypeLabel' | translate }}
            </label>
        </div>

            <div class="col-md-3 col-lg-3 col-xl-3">
                <select class="form-control custom-select" id="sd_contact_type" name="contactType" (change)="changeContactType()" formControlName="contactType">
                  <option *ngFor="let option of contactTypeOptions; let i = index" value="{{i}}">{{ 'ContactInfo.'+option | translate }}</option> 
        
                </select>
              </div>
        
              <div class="col-md-3 col-lg-3 col-xl-3">
                <input class="form-control" id="sd_contact_phone_input" *ngIf="!isContactTypeNone && isPhone" (focus)="phoneFocus = true" (blur)="phoneFocus = false" type="text" name="contactType" formControlName="phone"
                [ngClass]="{'error-class': (contactInfoForm.controls['phone'].touched) &&  contactInfoForm.controls['phone'].errors?.required && !phoneFocus}">

        
                <div *ngIf="!isContactTypeNone && isPhone && contactInfoForm.controls['phone'].touched &&  contactInfoForm.controls['phone'].errors?.required && !phoneFocus" class="validation-error-inline text-danger">
                  {{ 'ContactInfo.phoneRequiredError' | translate }}
                </div>
                <input class="form-control" id="sd_contact_email_input" type="email" *ngIf="!isContactTypeNone && !isPhone" (focus)="emailFocus = true" (blur)="emailFocus = false"
                  name="contactType" formControlName="email" keyup="emailValidation()" [ngClass]="{'error-class': (emailEmpty() && contactInfoForm.controls['email'].touched && !emailFocus) || emailValidation() &&  contactInfoForm.controls['email'].dirty}">
                <div *ngIf="!isContactTypeNone && !isPhone && emailEmpty() && contactInfoForm.controls['email'].touched && !emailFocus" class="validation-error-inline text-danger">
                  {{ 'ContactInfo.emailRequiredError' | translate }}
                </div>
                <div *ngIf="!isContactTypeNone && !isPhone && emailValidation() &&  contactInfoForm.controls['email'].dirty" class="validation-error-inline text-danger">
                  {{ 'ContactInfo.emailInvalidError' | translate }}
                </div>
              </div>
      </div>
  
      <!--Preferred Time -->
    <div class="form-group" *ngIf="!isContactTypeNone && isPhone">
      <div class="row mt-3">
        <div class="col-md-2 col-lg-2 col-xl-2">
            <label class="ml-2" for="contactTime" id="sd_contact_time_label">
                {{ 'ContactInfo.contactTimeLabel' | translate }}
            </label> 
        </div>
            <div class="col-md-3 col-lg-3 col-xl-3">
                <select class="form-control custom-select" id="sd_contact_time" formControlName="contactTime"  #ct (change)="checkcontactTimeValue(ct.value)">
                  <option></option>
                  <option *ngFor="let time of contactTimeOptions; let i = index" value="{{i}}">{{ 'ContactInfo.'+time | translate }}</option>
                </select>
              </div>

              <div class="col-md-3 col-lg-3 col-xl-3" *ngIf="showMeridiem">
                <select class="form-control custom-select" id="sd_contact_time_tt" formControlName="contactTimeTt">
                  <option *ngFor="let option of contactTimePeriodOptions; let i = index" value="{{i}}">{{ option }}</option> 
                
                </select>
              </div>
        </div>
      </div>
    </div>
  </div>